export const scrollTo = (elementId: string) => {
  if (!!document) {
    const selectorId = `#${elementId}`;
    document.querySelector(selectorId)?.scrollIntoView({
      behavior: 'smooth',
    });
  }
};
